import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface MetaEntity {
      id?: string; 
      code: string; 
      name: string; 
      description?: string;
      version?: number; 
      viewmode?: string;
      moduleCode?: string;
      transType?: string;
      placement?: string;
      dataFlow?: string;
}

@Injectable({ providedIn: 'root' })
export class MetaService {
      //  https://localhost:7056/api/metaentities/allentity
      private api = `${environment.apiUrl}/api/metaentities`; // Your API Port
      constructor(private http: HttpClient) { }
      getAllEntities(): Observable<any[]> {
            return this.http.get<any[]>(`${this.api}/allentity`);
      }
      getAll = (pageIndex: number, pageSize: number, search: string = '') => {
            const params = {
                  pageIndex: pageIndex.toString(),
                  pageSize: pageSize.toString(),
                  search: search
            };

            return this.http.get<{ items: MetaEntity[], totalCount: number }>(this.api, { params });
      };
      add = (dto: MetaEntity) => this.http.post(this.api, dto);
      update = (id: string, dto: MetaEntity) => this.http.put(`${this.api}/${id}`, dto);
      remove = (id: string) => this.http.delete(`${this.api}/${id}`);

      getEntityByCode(code: string): Observable<MetaEntity> {
            return this.http.get<MetaEntity>(`${this.api}/entitybycode/${code}`);
      }
}